import * as React from 'react';
import * as ReactRouter from 'react-router';
import {RollbarLogger} from 'wnd-logger/lib/rollbarLogger';
import {withRouter, RouteComponentProps} from 'react-router-dom';
import {AuthErrorPage} from '>root/pages/authErrorPage';

interface Props extends RouteComponentProps {
  rollbarLogger: RollbarLogger;
  children?: React.ReactNode;
}

interface State {
  error?: Error;
}

// error boundaries must be class components as of React 16
class Boundary extends React.Component<Props, State> {
  private promiseRejectionHandler = (event: PromiseRejectionEvent) => {
    this.props.rollbarLogger.error(event.reason);
  };

  state: State = {};

  componentDidCatch(error: Error): void {
    const {rollbarLogger} = this.props;
    rollbarLogger.error(error);
    this.setState({error});
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.promiseRejectionHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
  }

  render(): React.ReactNode {
    const {state, props} = this;

    if (state.error) {
      return <AuthErrorPage />;
    }
    return props.children;
  }
}

export const RouterErrorBoundary = withRouter(Boundary);
